export default class Auth {
    logout() {
        localStorage.removeItem('access_token');
        localStorage.removeItem('id_token');
        localStorage.removeItem('expires_at');
        window.location.reload()
    }

    isAuthenticated() {
        const expirationString = localStorage.getItem('expires_at')
        if (typeof expirationString === 'string'){
            const expiresAt = new Date(expirationString)
            const now = new Date()
            return now < expiresAt;
        }
        return false
    }
}